export enum VisibiliteEnum {
    PRIVE = 'PRIVE',
    PUBLIC_UTILISATEURS = 'PUBLIC_UTILISATEURS',
    PUBLIC_ADHERENTS = 'PUBLIC_ADHERENTS'
}
